import * as types from '../constants/login';
import { mapErrorMessage } from '../../Utils/mapErrorMessage';
import { auth } from '../../Utils/auth';
import { toast } from 'react-toastify';

const INITIAL_STATE = {
  isLoading: false,
  success: false,
  error: null,
  token: auth.getToken(), // Utils/auth owns the token; Redux only mirrors it
  user: null,
  user_information: null,
  loginCallback: null,
};

export default function loginApiReducer(state = INITIAL_STATE, action) {
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    // LOGIN
    case types.API_LOGIN_REQUEST:
      return {
        ...newState,
        isLoading: true,
        success: false,
        error: null,
        token: null,
        user_information: null,
      };

    case types.API_LOGIN_REQUEST_SUCCESS:
      return {
        ...newState,
        isLoading: false,
        success: true,
        error: null,
        token: action.response.data.token,
        user: action.response.data?.user,
        user_information: action.response.data?.user_information,
      };

    case types.API_LOGIN_REQUEST_FAILED:
      return {
        ...newState,
        isLoading: false,
        success: false,
        error: action.payload,
      };

    // GOOGLE LOGIN
    case types.API_GOOGLE_LOGIN_REQUEST:
      return {
        ...newState,
        isLoading: true,
        success: false,
        error: null,
        token: null,
        user_information: null,
      };

    case types.API_GOOGLE_LOGIN_SUCCESS:
      return {
        ...newState,
        isLoading: false,
        success: true,
        error: null,
        token: action.payload.token,
        user: action.payload.user,
        user_information: action.payload.user_information,
      };

    case types.API_GOOGLE_LOGIN_FAILED:
      return {
        ...newState,
        isLoading: false,
        success: false,
        error: action.payload,
      };

    // Request password reset
    case types.API_PASSWORD_RESET_REQUEST:
      return {
        ...newState,
        isLoading: true,
        success: false,
        error: null,
      };

    case types.API_PASSWORD_RESET_SUCCESS:
      return {
        ...newState,
        isLoading: false,
        success: true,
        error: null,
      };

    case types.API_PASSWORD_RESET_FAILED:
      return {
        ...newState,
        isLoading: false,
        success: false,
        error: mapErrorMessage(action),
      };

    // Request password reset confirm
    case types.API_PASSWORD_RESET_CONFIRM_REQUEST:
      return {
        ...newState,
        isLoading: true,
        success: false,
        error: null,
      };

    case types.API_PASSWORD_RESET_CONFIRM_SUCCESS:
      toast.success(action.response?.data?.message);
      return {
        ...newState,
        isLoading: false,
        success: true,
        error: null,
      };

    case types.API_PASSWORD_RESET_CONFIRM_FAILED:
      return {
        ...newState,
        isLoading: false,
        success: false,
        error: mapErrorMessage(action),
      };

    case types.SET_USER_INFORMATION:
      return {
        ...newState,
        user_information: action.data,
      };

    case types.CLEAR_TOKEN:
      auth.logout();
      return {
        isLoading: false,
        success: false,
        error: null,
        token: null,
        user: null,
        user_information: null,
      };

    case types.RESET_MSG:
      return {
        ...newState,
        success: false,
        error: null,
      };

    case types.LOGIN_CALLBACK:
      return {
        ...newState,
        loginCallback: action.payload,
      };

    default:
      return state;
  }
}
